// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".e024fc6ffd47a27174d509ed1450d4f15f7126a8.chunk.js";
};